module.exports = __webpack_public_path__ + "img/C2M产业模型.2de515d5.png";